
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLimitsOutsideOver as ObiLimitsOutsideOverElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-limits-outside-over.js';
 
 
 

 
 export const ObiLimitsOutsideOver = createComponent({
   react: React,
   tagName: 'obi-limits-outside-over',
   elementClass: ObiLimitsOutsideOverElement,
   events: {
     
   }
  });
 
 